import React from 'react';
import { IFormData } from '@/interfaces/form.model';
import PrimaryInput from '@/components/ui/PrimaryInput';
import Button from '@/components/ui/Button';

interface IFormMetadataConfigProps {
  formData: IFormData;
  onChange: (field: keyof IFormData, value: any) => void;
  onNext: () => void;
  isViewMode?: boolean;
}

const FormMetadataConfig: React.FC<IFormMetadataConfigProps> = ({
  formData,
  onChange,
  onNext,
  isViewMode,
}) => {
  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-body p-4">
        <h5 className="card-title mb-4">Step 1: Form Metadata</h5>
        <div className="row g-3">
          <div className="col-12">
            <PrimaryInput
              label="Form Name"
              placeholder="Enter form name"
              value={formData.name || ''}
              onChange={(e) => onChange('name', e.target.value)}
              required
              disabled={isViewMode}
            />
          </div>
          <div className="col-12">
            <label className="form-label">
              Description <span className="text-secondary">(Optional)</span>
            </label>
            <textarea
              className="form-control"
              rows={3}
              placeholder="Enter form description"
              value={formData.description || ''}
              onChange={(e) => onChange('description', e.target.value)}
              disabled={isViewMode}
            />
          </div>
          <div className="col-12">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              // value={formData.status}
              onChange={(e) => onChange('status', e.target.value)}
              disabled={isViewMode}
            >
              <option value="draft">Draft</option>
              <option value="published">Published</option>
              <option value="archived">Archived</option>
            </select>
          </div>

          <div className="col-12 d-flex justify-content-end mt-4">
            <Button
              className="btn btn-primary px-4"
              type="button"
              onClick={onNext}
              disabled={!formData.name?.trim()}
            >
              {isViewMode ? 'View Sections' : 'Next: Manage Sections'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormMetadataConfig;
